import 'client_libs';

let commonContext = require.context('../javascripts/common', true, /\.js$/);
commonContext.keys().forEach(commonContext);

let clientContext = require.context('../javascripts/client', true, /\.js$/);
clientContext.keys().forEach(clientContext);